import {
  CustomForm,
  CustomFormPageFieldUuidToSignatureBase64Map,
} from '@flicent/fieldpulse-react-component-library-frontend';

import { ApiServiceInstance } from './Api.service';


interface RequestParams {
  token: string;
  formTemplateId: string;
  form: CustomForm;
}

interface ResponseDataType {
  is_form_attached_to_record: boolean;
  new_signer_names: string[] | null;
  form: CustomForm;
  page_field_uuid_to_signature_base64_map: CustomFormPageFieldUuidToSignatureBase64Map;
}

export const createCustomFormRequest = ({
                                          token,
                                          formTemplateId,
                                          form,
                                        }: RequestParams): Promise<ResponseDataType> => {
  return ApiServiceInstance.makeRequest(`/custom-form?form_template_id=${ formTemplateId }`, {
    method: 'POST',
    token,
    body: form,
  });
};